import { DataGrid } from "devextreme-react";
import { Column, ColumnChooser, Grouping, GroupPanel, Pager, Paging, SearchPanel } from "devextreme-react/data-grid";
import { ITransferEmployeeTransactionRecordDto } from "../../../dtos/transactions/ITransferEmployeeTransactionRecordDto";
import { IAccruedVatTransactionRecordDto } from "../../../dtos/transactions/IAccruedVatTransactionRecordDto";

interface IProps {
  items: IAccruedVatTransactionRecordDto[];
}

export const AccruedVatTransactionRecordTable = ({ items }: IProps) => {
  const pageSizes = [10, 25, 50, 100];

  return (
    <>
      <div className={"overflow-auto"}>
        <DataGrid
          dataSource={items}
          sorting={{ mode: "multiple" }}
          allowColumnReordering={true}
          rowAlternationEnabled={false}
          showBorders={false}
          showRowLines={true}
          allowColumnResizing={true}
          selection={{ mode: "single" }}
          loadPanel={{ enabled: true, showIndicator: true, showPane: false }}
        >
          <ColumnChooser enabled={true} />
          <GroupPanel visible={true} />
          <SearchPanel visible={true} highlightCaseSensitive={true} />
          <Grouping autoExpandAll={false} />

          <Column width={150} dataField="period" dataType={"datetime"} caption="Period" sortOrder={"asc"} sortIndex={1} />
          <Column width={150} dataField="documentId" dataType={"string"} caption="Document " />
          <Column width={150} dataField="movementType" dataType={"number"} caption="Movement Type" />
          <Column width={150} dataField="recorderType" dataType={"number"} caption="Recorder Type" />
          <Column width={150} dataField="branchId" dataType={"string"} caption="Branch" />
          <Column width={150} dataField="accountId" dataType={"string"} caption="Account" />
          <Column width={150} dataField="vatArticleId" dataType={"string"} caption="Vat Article" />
          <Column width={150} dataField="amountWithoutVat" dataType={"number"} caption="Amount Without Vat" />
          <Column width={150} dataField="vat" dataType={"number"} caption="Vat" />

          <Paging defaultPageSize={10} />
        </DataGrid>
      </div>
    </>
  );
};
